export const activeEnv = (process.env.GATSBY_ACTIVE_ENV ||
  process.env.NODE_ENV ||
  'development') as string;

export const API_URL = 'https://neko.api.wallet.bitcoin.com:82/api/v1/stats';
